export const setTDK = (keywords = '', description = '') => {
    const setMetaContent = (name, content) => {
        let metaTag = document.querySelector(`meta[name="${name}"]`)
        if (!metaTag) {
            metaTag = document.createElement('meta')
            metaTag.setAttribute('name', name)
            document.head.appendChild(metaTag)
        }
        metaTag.setAttribute('content', content)
    }

    const setPropertyContent = (property, content) => {
        let metaTag = document.querySelector(`meta[property="${property}"]`)
        if (!metaTag) {
            metaTag = document.createElement('meta')
            metaTag.setAttribute('property', property)
            document.head.appendChild(metaTag)
        }
        metaTag.setAttribute('content', content)
    }

    setMetaContent('keywords', keywords)
    setMetaContent('description', description)
    setPropertyContent('og:description', description)
}
